export default "__VITE_ASSET__b5e15411__"